/**
 * OptonLists
 * 
 * @Author: Focci
 * @Date: 2023-08-29 15:02:00
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-29 15:02:00
 */

// import PropTypes from 'prop-types'
import clsx from 'clsx'
import { ButtonBase } from '@comp/material'
import { filter, isArray } from 'lodash-es'

export default function Lists({ 
  option, 
  selectedItems,
  onChange = () => {}
}) {
  const { lists, columnName } = option
  const selectedValue = filter(selectedItems, (f) => f.field === columnName)[0]?.value
  
  return isArray(lists) && lists.map((list) => {
    const actived = selectedValue === list.value
    
    return (
      <ButtonBase
        key={columnName + list.value}
        className="rounded-md"
        onClick={() => onChange(list)}
      >
        <div 
          className={clsx([
            'flex flex-col items-center justify-center gap-y-6',
            'border border-2 rounded-md',
            !actived ? 'border-transparent bg-[#F2F5F7]' : 'border-primary text-primary',
            list.iconActive ? 'max-w-[12rem] p-6 md:p-8' : 'p-4'
          ])}
        >
          {list.iconActive && (
            <img
              src={actived ? list.iconActive : list.icon}
              alt={list.label}
              width={50}
              height={50}
              style={{ width: '2.5rem', height: '2.5rem', objectFit: 'contain' }}
            />
          )}
          <span className="text-f.8 line-clamp-3">
            {list.label}
          </span>
        </div>
      </ButtonBase>
    )
  })
}

// OptonLists.propTypes = {
//   className: PropTypes.string,
// }
